import React from 'react';

export const MAIN_ICONS = [
  { name: 'blue', alt: 'blue' },
  { name: 'cloud', alt: 'cloud' },
  { name: 'flower', alt: 'flower' },
  { name: 'curve', alt: 'curve' },
];

export const CONCEPT = {
  title: (
    <>
      A little frame with grown-up <br />
      confidence—smart, sturdy, and made to keep up with curious minds and everyday wonder
    </>
  ),
  alt: `A little frame with grown-up confidence—smart, sturdy, and made to keep up with curious minds and everyday wonder`,
  desc: `A kids’ eyewear collection born from the belief that fashion isn’t just for grown-ups. Thoughtfully crafted for comfort and the perfect fit, each frame is designed with a playful spirit and a child-friendly touch.`,
  button: {
    label: 'Junni All Products',
    link: '/sg/en/eyeglasses/brands/Junni.html',
  },
};

export const FEATURES = {
  title: 'FEATURES',
  subTitle: '3 Fun-tastic features of OWNDAYS Kids’ spectacles',
  list: [
    {
      title: 'Light as a Feather, Tough as a Hero! Just Safe, Sturdy Style!',
      alt: 'Light as a Feather, Tough as a Hero! Just Safe, Sturdy Style!',
    },
    {
      title: 'Stays Put While You Run, Jump, and Play!',
      alt: 'Stays Put While You Run, Jump, and Play!',
    },
    {
      title: 'Style That Says ‘Big Kid Energy’',
      alt: 'Style That Says ‘Big Kid Energy’',
    },
  ],
};

export const LINEUP_NAV = {
  title: 'LINEUP',
  list: [
    {
      title: 'TREND',
      alt: 'TREND',
      img: '/lineup-nav-trend.webp',
    },
    {
      title: 'SPORTS',
      alt: 'SPORTS',
      img: '/lineup-nav-sports.webp',
    },
    {
      title: 'STANDARD',
      alt: 'STANDARD',
      img: '/lineup-nav-standard.webp',
    },
  ],
};

export const STYLES = [
  {
    id: 'trend',
    title: 'TREND',
    description: 'Fashion-forward frames for mini trendsetter',
    stickers: ['sticker-trend-1.webp', 'sticker-trend-2.webp'],
    products: [
      {
        code: 'JU2039N-4S',
        price: 158,
        colors: [
          {
            id: 'C1',
            img: 'JU2039N-4S_C1_01.webp',
            colorImg: 'color-1.webp',
            url: 'junni-ju2039n-4s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU2039N-4S_C2_01.webp',
            colorImg: 'color-2.webp',
            url: 'junni-ju2039n-4s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU2039N-4S_C3_01.webp',
            colorHex: '#E7E7E7',
            url: 'junni-ju2039n-4s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU2039N-4S_C4_01.webp',
            colorHex: '#FCE4E6',
            url: 'junni-ju2039n-4s-c4-eyeglasses.html',
          },
        ],
      },
      {
        code: 'JU1024G-4S',
        price: 158,
        colors: [
          {
            id: 'C1',
            img: 'JU1024G-4S_C1_01.webp',
            colorHex: '#865929',
            url: 'junni-ju1024g-4s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU1024G-4S_C2_01.webp',
            colorHex: '#2E5299',
            url: 'junni-ju1024g-4s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU1024G-4S_C3_01.webp',
            colorImg: 'color-3.webp',
            url: 'junni-ju1024g-4s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU1024G-4S_C4_01.webp',
            colorHex: '#593877',
            url: 'junni-ju1024g-4s-c4-eyeglasses.html',
          },
        ],
      },
      {
        code: 'JU1022G-1A',
        price: 158,
        colors: [
          {
            id: 'C1',
            img: 'JU1022G-1A_C1_01.webp',
            colorHex: '#000',
            url: 'junni-ju1022g-1a-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU1022G-1A_C2_01.webp',
            colorHex: '#865929',
            url: 'junni-ju1022g-1a-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU1022G-1A_C3_01.webp',
            colorHex: '#0E348B',
            url: 'junni-ju1022g-1a-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU1022G-1A_C4_01.webp',
            colorHex: '#F69AC1',
            url: 'junni-ju1022g-1a-c4-eyeglasses.html',
          },
        ],
      },
    ],
  },
  {
    id: 'sports',
    title: 'SPORTS',
    description: 'Designed to stay put, no matter the adventure',
    stickers: ['sticker-sports-1.webp', 'sticker-sports-2.webp'],
    products: [
      {
        code: 'JU2041N-5S',
        price: 118,
        new: true,
        colors: [
          {
            id: 'C1',
            img: 'JU2041N-5S_C1_01.webp',
            colorHex: '#333333',
            url: 'junni-ju2041n-5s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU2041N-5S_C2_01.webp',
            colorHex: '#0E348B',
            url: 'junni-ju2041n-5s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU2041N-5S_C3_01.webp',
            colorHex: '#E7E7E7',
            url: 'junni-ju2041n-5s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU2041N-5S_C4_01.webp',
            colorHex: '#2E5299',
            url: 'junni-ju2041n-5s-c4-eyeglasses.html',
          },
        ],
        features: [
          'Light as a feather, cozy as your fave tee',
          'Replaceable silicone nose pads for a perfect fit',
          'Vibrant colours ready to race',
        ],
      },
      {
        code: 'JU2042N-5S',
        price: 158,
        new: true,
        colors: [
          {
            id: 'C1',
            img: 'JU2042N-5S_C1_01.webp',
            colorHex: '#333333',
            url: 'junni-ju2042n-5s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU2042N-5S_C2_01.webp',
            colorHex: '#97959C',
            url: 'junni-ju2042n-5s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU2042N-5S_C3_01.webp',
            colorHex: '#E7E7E7',
            url: 'junni-ju2042n-5s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU2042N-5S_C4_01.webp',
            colorHex: '#2E5299',
            url: 'junni-ju2042n-5s-c4-eyeglasses.html',
          },
        ],
        features: [
          'Temples that flex and stick, no matter how wild you get!',
          'Nose pads that hug softly and adjust just right',
          'Everyday styles that keep it simple and practical',
        ],
      },
      {
        code: 'JU1025G-5S',
        price: 158,
        new: true,
        colors: [
          {
            id: 'C1',
            img: 'JU1025G-5S_C1_01.webp',
            colorHex: '#000000',
            url: 'junni-ju1025g-5s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU1025G-5S_C2_01.webp',
            colorHex: '#865929',
            url: 'junni-ju1025g-5s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU1025G-5S_C3_01.webp',
            colorHex: '#0E348B',
            url: 'junni-ju1025g-5s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU1025G-5S_C4_01.webp',
            colorImg: 'color-3.webp',
            url: 'junni-ju1025g-5s-c4-eyeglasses.html',
          },
        ],
        features: [
          'Rust and tarnish don’t stand a chance with this stainless steel',
          'Comfort meets flexibility with spring hinges that never pinch',
          'A minimalist take on the classic unisex Boston style',
        ],
      },
    ],
  },
  {
    id: 'standard',
    title: 'STANDARD',
    description: 'Forever classic, forever chic',
    stickers: [
      'sticker-standard-1.webp',
      'sticker-standard-2.webp',
      'sticker-standard-3.webp',
      'sticker-standard-4.webp',
    ],
    products: [
      {
        code: 'JU2037N-4S',
        price: 118,
        colors: [
          {
            id: 'C1',
            img: 'JU2037N-4S_C1_01.webp',
            colorImg: 'color-1.webp',
            url: 'junni-ju2037n-4s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU2037N-4S_C2_01.webp',
            colorImg: 'color-4.webp',
            url: 'junni-ju2037n-4s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU2037N-4S_C3_01.webp',
            colorHex: '#E6F3FF',
            url: 'junni-ju2037n-4s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU2037N-4S_C4_01.webp',
            colorHex: '#FCE4E6',
            url: 'junni-ju2037n-4s-c4-eyeglasses.html',
          },
        ],
      },
      {
        code: 'JU1023C-4S',
        price: 118,
        colors: [
          {
            id: 'C1',
            img: 'JU1023C-4S_C1_01.webp',
            colorHex: '#865929',
            url: 'junni-ju1023c-4s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU1023C-4S_C2_01.webp',
            colorHex: '#253B5E',
            url: 'junni-ju1023c-4s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU1023C-4S_C3_01.webp',
            colorHex: '#CEB39C',
            url: 'junni-ju1023c-4s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU1023C-4S_C4_01.webp',
            colorImg: 'color-3.webp',
            url: 'junni-ju1023c-4s-c4-eyeglasses.html',
          },
        ],
      },
      {
        code: 'JU2040N-4S',
        price: 158,
        colors: [
          {
            id: 'C1',
            img: 'JU2040N-4S_C1_01.webp',
            colorHex: '#000000',
            url: 'junni-ju2040n-4s-c1-eyeglasses.html',
          },
          {
            id: 'C2',
            img: 'JU2040N-4S_C2_01.webp',
            colorHex: '#CEB39C',
            url: 'junni-ju2040n-4s-c2-eyeglasses.html',
          },
          {
            id: 'C3',
            img: 'JU2040N-4S_C3_01.webp',
            colorHex: '#E6F3FF',
            url: 'junni-ju2040n-4s-c3-eyeglasses.html',
          },
          {
            id: 'C4',
            img: 'JU2040N-4S_C4_01.webp',
            colorHex: '#FCE4E6',
            url: 'junni-ju2040n-4s-c4-eyeglasses.html',
          },
        ],
      },
    ],
  },
];

export const OPTIONAL_LENSES = [
  {
    img: 'lens-color.webp',
    title: 'Colour Lenses',
    description:
      'Pair them with your favourite spectacle frame to elevate your style or use them as sunglasses',
    url: '/sg/en/services/lens#color',
  },
  {
    img: 'lens-pc.webp',
    title: 'Blue Light Lenses',
    description: 'Protect your eyes from blue light when using the computer or smartphone',
    url: '/sg/en/services/lens#blue-light-lenses',
  },
  {
    img: 'lens-antifog.webp',
    title: 'Anti-Fog Lenses',
    description:
      'With a special coating that prevents the lenses from fogging up, keeping your vision crystal clear at all times',
    url: '/sg/en/services/lens#antifog',
  },
];

export const TIPS = [
  {
    img: '4-signs-that-indicate-you-should-get-your-eyes-checked.webp',
    description: 'Top 4 Signs That Indicate You Should Get Your Eyes Checked',
    url: '/sg/en/articles/4-signs-that-indicate-you-should-get-your-eyes-checked',
  },
  {
    img: 'why-it-is-important-to-get-your-eye-prescription-right.webp',
    description: 'Why It Is Important To Get Your Eye Prescription Right',
    url: '/sg/en/articles/why-it-is-important-to-get-your-eye-prescription-right',
  },
];
